import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles({
  dialogBox: {
    position: 'relative',
  },
  dialogContent: {
    width: '500px',
    margin: '10px',
    padding: '10px',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  headerTitle: {
    margin: '10px',
  },
  footerSection: {
    margin: '10px',
  },
});

export interface PopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dialogProps: any;
}

const SimilarPromptPopup = ({
  open,
  onClose,
  onConfirm,
  dialogProps,
}: PopupProps) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      className={classes.dialogBox}
      fullWidth={false}
    >
      <DialogTitle id="dialog-title">
        <div className={classes.dialogHeader}>
          <InfoOutlined color="error" />
          <span className={classes.headerTitle}>Found similar prompt(s)</span>
        </div>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => onClose()}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Typography>
          Please check the existing similar prompt(s) before saving new.
        </Typography>
      </DialogContent>
      <DialogActions className={classes.footerSection}>
        <Button
          color="primary"
          onClick={() => onConfirm()}
          data-testid="no-btn"
          variant="contained"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimilarPromptPopup;
